import {NgModule} from '@angular/core';
import {CypressDataDirective} from './cypress-data.directive';

@NgModule({
  imports: [],
  declarations: [
    CypressDataDirective,
  ],
  exports: [
    CypressDataDirective,
  ],
})
export class DirectivesModule { }
